// @ts-strict-ignore
import { ComponentMultiStyleConfig } from '@chakra-ui/react'
import { Button } from './Button'

export const Tabs: Partial<ComponentMultiStyleConfig> = {
  variants: {
    line: ({ orientation }) => {
      const borderProp =
        orientation === 'vertical' ? 'borderStart' : 'borderBottom'

      return {
        tab: {
          [borderProp]: '2px solid',
          color: 'product.text.dark.bodySolid',
          borderWidth: 0,
          fontWeight: 'medium',
          px: 3,
          py: 2,
          _selected: {
            [borderProp]: '2px solid',
            opacity: 1,
            color: 'product.cgBlue',
            borderBottomColor: 'product.secondary',
          },
        },
        tablist: {
          borderColor: '#C5C9D9',
          borderBottomWidth: 1,
        },
        tabpanel: {
          py: 4,
          px: '2px',
        },
      }
    },
    picker: {
      tab: {
        ...Button.variants.tab,
      },
    },
    toggle: {
      tab: {
        ...Button.variants.toggle,
      },
    },
  },
  sizes: {
    sm: {
      tab: {
        borderRadius: 'base',
        py: 2,
        px: 2,
      },
    },
    lg: {
      tab: {
        px: 6,
        py: 4,
        borderRadius: 'lg',
        fontSize: 'md',
      },
    },
  },
}
